<script>
  import FormLogin from '@components/Form/Login'
  import FormRegister from '@components/Form/Register'
  import dialogMixin from "./mixins/dialog";


  export default {
    components: {
      FormLogin,
      FormRegister,
    },
    mixins: [dialogMixin],
    props: {
      type: {
        type: String,
        default: 'login',
        validator(value) {
          return [
            'login',
            'register',
          ].includes(value)
        },
      }
    },
    data() {
      return {
        activeTab: 'FormLogin'
      }
    },
    methods: {
      changeTab(value) {
        this.activetab = value;
      },
      onLogin() {
        this.$emit('login')
      },
      handleRegistered() {
        this.activeTab = "FormLogin"
      },
      goToResiger() {
        this.$nextTick(()=> {
          this.activeTab = 'FormRegister'
        })
      }
    },
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogLogin } isStyleLogin`"
    width="876px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-tabs
      v-model="activeTab"
      class="isStyleBase"
      stretch
    >
      <el-tab-pane label="登入" name="FormLogin"></el-tab-pane>
      <el-tab-pane label="註冊" name="FormRegister"></el-tab-pane>
    </el-tabs>
    <component 
      :is="activeTab" 
      :hide-title="true" 
      @login="onLogin"
      @done="handleRegistered"
      @toResiger="goToResiger"
    >
    </component>
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogLogin {
    :global {

    }
  }
</style>
